import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ProgramDataProxy } from "@entities/program/api/data.proxy";
import { useIonRouter } from "@ionic/react";
import { toast } from "sonner";
import { ROUTES } from "@shared/constants/routes";
import { CustomLoader } from "@/shared/animations/loaders/CustomLoader";
import { DefaultPage } from "@shared/layout/DefaultPage";

const ENROLLMENT_REDIRECT_STALE_TIME_MS = 30 * 1000;

export const ProgramRedirectPage = () => {
  const { enrollmentId } = useParams<{ enrollmentId: string | undefined }>();
  const nav = useIonRouter();
  const [redirectAttempted, setRedirectAttempted] = useState(false);

  const {
    data: program,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery({
    queryKey: ["enrollment", enrollmentId],
    queryFn: async () => {
      if (!enrollmentId) {
        return Promise.reject(new Error("No enrollment ID provided"));
      }
      return ProgramDataProxy.getEnrollmentById(+enrollmentId);
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    staleTime: ENROLLMENT_REDIRECT_STALE_TIME_MS,
    enabled: !!enrollmentId,
  });

  useEffect(() => {
    if (redirectAttempted) {
      return;
    }
    if (isFetching) {
      return;
    }

    if (!enrollmentId) {
      nav.push(ROUTES.overall.main, "none", "replace");
      setRedirectAttempted(true);
    } else if (isError) {
      toast.error("Не удалось загрузить программу.");
      nav.push(ROUTES.overall.main, "none", "replace");
      setRedirectAttempted(true);
    } else if (isSuccess) {
      if (program) {
        nav.push(
          `/program/${enrollmentId}/week/${program.pointer_week}`,
          "none",
          "replace",
        );
      } else {
        toast.error("Программа не найдена. Перенаправление на главную.");
        nav.push(ROUTES.overall.main, "none", "replace");
      }
      setRedirectAttempted(true);
    }
  }, [
    program,
    isError,
    isSuccess,
    isFetching,
    nav,
    enrollmentId,
    redirectAttempted,
  ]);

  if (isLoading) {
    return (
      <DefaultPage noPadding style={{ background: "#F8F8F3" }}>
        <main className="flex h-full w-full items-center justify-center bg-[#F8F8F3]">
          <CustomLoader />
        </main>
      </DefaultPage>
    );
  }
  if (!redirectAttempted) {
    return (
      <DefaultPage noPadding style={{ background: "#F8F8F3" }}>
        <main className="flex h-full w-full items-center justify-center bg-[#F8F8F3]">
          <CustomLoader />
        </main>
      </DefaultPage>
    );
  }

  return null;
};
